import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import { RegisterModalComponent } from 'components/RootModal/modalRegistry';

import type { Goal } from 'app-components/flux/goals/goalsTypes';
import EditGoal from './index';

export type EditGoalResult = {
  success: boolean;
  goalId?: string;
  error?: string;
};

const EDIT_DIALOG_TYPE = 'GOALS_EDIT_DIALOG';
RegisterModalComponent(EDIT_DIALOG_TYPE, EditGoal);
// This action will allow for editing of an existing goal
export const EditGoalAction = createAction(
  rootUiActions.createDialog.toString(),
  (props: { goal: Goal; context?: string; callback?: (result: EditGoalResult) => void }) =>
    rootUiTypes.mkRootUiData({
      type: EDIT_DIALOG_TYPE,
      props: ImmutableMap({
        goal: props.goal,
        context: props.context,
        callback: props.callback,
      }),
    }),
);
